import flaggb from "../assets/images/flags/gb.svg";
import flagpoland from "../assets/images/flags/pl.svg";
import flaggermany from "../assets/images/flags/de.svg";

const languages = {
  pl: {
    label: "Polski",
    flag: flagpoland,
  },
  de: {
    label: "Deutsch",
    flag: flaggermany,
  },
  en: {
    label: "English",
    flag: flaggb,
  },
}

export default languages
